// extracted by mini-css-extract-plugin
export default {"container":"UserCard_container__6f+4G","main":"UserCard_main__nmGVB","header":"UserCard_header__bjDRW","content":"UserCard_content__B01Tg"};